module.exports = __webpack_public_path__ + "2684f399013e8d53caa1b0dabc3cddea.svg";